import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import services from '../../services';
import { useDispatch } from 'react-redux';
import { toggleDate, toggleTable } from '../../Redux/slice';
import { getAllDateTableTask } from '../../Redux/GetSlice';
import { getLocalStorageItem, setLocalStorageItem } from '../../utils/Localstorage/localStorageUtils';

const ArchivedHeader = ({ isArchivedView, boardIds, availableBoards, onBoardIdsChange, searchValue, onSearchChange, filtersOpen, onToggleFilters }) => {
    const [activeButton, setActiveButton] = useState('board');
    const [boardName, setBoardName] = useState([]);
    const [navBoard, setNavBoard] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        getAllBoard();
    }, []);

    const getAllBoard = async () => {
        try {
            const { data } = await services.board.GETALLBOARD();
            const mapData = data?.map(({ boardName, id }) => ({ label: boardName, value: id }));
            setBoardName(mapData);
            const savedBoardId = getLocalStorageItem('boardId')
            if (savedBoardId && mapData.length > 0) {
                const board = mapData.find((b) => b.value === savedBoardId);
                setNavBoard(board || mapData[0]);
            } else if (mapData.length > 0) {
                setNavBoard(mapData[0]);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleClick = (button) => {
        setActiveButton(button);
        const boardId = navBoard?.value;

        if (button === 'board') {
            dispatch(toggleTable(false));
            dispatch(toggleDate(false));
            navigate('/app');
        } else if (button === 'date') {
            if (boardId) {
                dispatch(getAllDateTableTask({ data: { boardId } }));
            }
            dispatch(toggleDate(true));
            dispatch(toggleTable(false));
            navigate('/app');
        } else if (button === 'table') {
            dispatch(toggleTable(true));
            dispatch(toggleDate(false));
            navigate('/app');
        }
    };

    const handleSelectedBoard = (e) => {
        setNavBoard(e);
        setLocalStorageItem('boardId', e?.value)
        window.location.reload();
    };

    const getButtonClass = (button) =>
        `p-[7px] ${activeButton === button ? 'bg-[#20212414]' : 'bg-white'
        } mr-[5px] items-center flex cursor-pointer text-black gap-[4px] rounded-[5px]`;

    return (
        <div className="header-app flex items-center justify-between px-4 py-3 border-b bg-white">
            <button
                onClick={() => { isArchivedView == false ? navigate("/kanban") : navigate(-1) }}
                className="px-4 py-2 font-semibold bg-white border rounded-md text-sm"
                style={{ color: '#1a7d3e', borderColor: '#1a7d3e' }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0faf4'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = '#fff'}
            >
                Back
            </button>
            <div className="flex items-center gap-3">
                {onSearchChange && (
                    <div className="relative">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#9ca3af" viewBox="0 0 16 16" className="absolute left-3 top-1/2 -translate-y-1/2">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                        </svg>
                        <input
                            type="text"
                            placeholder="Search in all archived tasks"
                            value={searchValue}
                            onChange={(e) => onSearchChange(e.target.value)}
                            className="pl-8 pr-3 py-2 border rounded-full text-sm w-[260px] focus:outline-none"
                            style={{ borderColor: '#d1d5db' }}
                        />
                    </div>
                )}

                {availableBoards !== undefined && (
                    <Select
                        value={availableBoards
                            .filter((board) => (boardIds || []).includes(board.id))
                            .map((board) => ({ value: board.id, label: board.boardName }))}
                        onChange={(opts) => onBoardIdsChange((opts || []).map((o) => o.value))}
                        options={availableBoards.map((board) => ({ value: board.id, label: board.boardName }))}
                        isMulti
                        isClearable
                        placeholder="All Boards"
                        styles={{
                            container: (base) => ({ ...base, minWidth: '220px' }),
                            control: (base, state) => ({
                                ...base,
                                minWidth: '220px',
                                fontSize: '14px',
                                borderColor: state.isFocused ? '#1a7d3e' : '#d1d5db',
                                boxShadow: state.isFocused ? '0 0 0 2px rgba(26,125,62,0.18)' : 'none',
                                '&:hover': { borderColor: '#1a7d3e' },
                                cursor: 'pointer',
                            }),
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                    ? '#1a7d3e'
                                    : state.isFocused
                                    ? '#e6f4ed'
                                    : '#fff',
                                color: state.isSelected ? '#fff' : '#222',
                                fontWeight: state.isSelected ? 600 : 400,
                                cursor: 'pointer',
                            }),
                            multiValue: (base) => ({ ...base, backgroundColor: '#e6f4ed' }),
                            multiValueLabel: (base) => ({ ...base, color: '#1a7d3e', fontWeight: 500 }),
                            indicatorSeparator: () => ({ display: 'none' }),
                            dropdownIndicator: (base) => ({ ...base, color: '#1a7d3e', padding: '0 8px' }),
                        }}
                    />
                )}

                {onToggleFilters && (
                    <button
                        type="button"
                        onClick={onToggleFilters}
                        className="flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium text-white"
                        style={{ backgroundColor: filtersOpen ? '#145c2c' : '#1a7d3e' }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 512 512">
                            <path d="M64 96h384v48H64zm80 136h224v48H144zm48 136h128v48H192z" />
                        </svg>
                        Filters
                    </button>
                )}
            </div>
        </div>
    );
};

export default ArchivedHeader; 